module.exports = __webpack_public_path__ + "img/buildings.40871ec9.svg";